import { call, put } from 'redux-saga/effects';
import { queryService } from '../services/queryService';
import { queryConstants } from '../actions/constants/queryConstants';
import { commonConstants } from '../actions/constants/commonConstants';

function* listQueries(action: any): any {
  try {
    const response = yield call(queryService.listQueries, action.payload);
    if (response && response.success) {
      yield put({ type: queryConstants.listQueriesSuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: queryConstants.listQueriesFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: queryConstants.listQueriesFailure, payload: error });
  }
}

function* saveQuery(action: any): any {
  try {
    const response = yield call(queryService.saveQuery, action.payload);
    if (response && response.success) {
      yield put({ type: queryConstants.saveQuerySuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Saved' });
    } else {
      yield put({ type: queryConstants.saveQueryFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: queryConstants.saveQueryFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* viewQuery(action: any): any {
  try {
    const response = yield call(queryService.viewQuery, action.payload);
    if (response && response.success) {
      yield put({ type: queryConstants.viewQuerySuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: queryConstants.viewQueryFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: queryConstants.viewQueryFailure, payload: error });
  }
}

function* deleteQuery(action: any): any {
  try {
    const response = yield call(queryService.deleteQuery, action.payload);
    if (response && response.success) {
      yield put({ type: queryConstants.deleteQuerySuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Deleted' });
    } else {
      yield put({ type: queryConstants.deleteQueryFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: queryConstants.deleteQueryFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* addRemarks(action: any): any {
  try {
    const { id, remarks } = action.payload || {};
    const response = yield call(queryService.addRemarks, id, remarks);
    if (response && response.success) {
      yield put({ type: queryConstants.addRemarksSuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Remarks added' });
    } else {
      yield put({ type: queryConstants.addRemarksFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: queryConstants.addRemarksFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

export const querySaga = {
  listQueries,
  saveQuery,
  viewQuery,
  deleteQuery,
  addRemarks
};
